import { Component } from '@angular/core';
import { SettingsComponent } from './settings.component';
import { BrowserService } from '../../../services/browser.service';
import { Share } from '@capacitor/share';
import { take } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { ClarityConfig } from '../../../config/clarity.config';
import { AnalyticsService } from '../../../services/analytics/analytics.service';
import * as navigationActions from '../../../store/session/actions/navigation.actions';
import { State } from '../../../store/state.reducer';
import { Store } from '@ngrx/store';
import { getCurrentUserProgram } from '../../../store/normalized/selectors/user.selectors';
import { SmokingType } from '../../../store/normalized/schemas/user.schema';
import { AnalyticsEvents } from 'src/app/services/analytics/analytics.events';

@Component({
  selector: 'cl-account-about',
  styleUrls: ['about.component.scss'],
  template: `
    <div class="about-holder">
      <p class="about-intro">
        <ng-container *ngIf="smokingType === 'cigarette'; else vapeTermsTemplate">
          {{"account_menu.about.terms" | translate}}
        </ng-container>
        <ng-template #vapeTermsTemplate>
          {{"account_menu.about.terms_vape" | translate}}
        </ng-template>
      </p>

      <p class="about-intro from-dr-jud">{{'account_menu.about.from_dr_jud' | translate}}</p>

      <p class="about-intro link" (click)="openTerms()">{{"account_menu.about.terms_info_link" | translate}}</p>

      <div class="action-buttons">
        <ion-row class="action-button ">
          <ion-col class="ion-text-center" auto>
            <cl-action-button
              class="outsider"
              (action)="openIntroVideo()"
              [label]="'welcome_tour.sliders.video.short_text' | translate"
              [canClick]="true">
            </cl-action-button>
          </ion-col>
        </ion-row>

        <ion-row class="action-button ">
          <ion-col class="ion-text-center" auto>
            <cl-action-button
              class="outsider"
              (action)="share()"
              [whiteBg]="true"
              [label]="'account_menu.about.share' | translate : {programName: config.program.name}"
              [canClick]="true">
            </cl-action-button>
          </ion-col>
        </ion-row>

        <ion-row class="action-button">
          <ion-col class="ion-text-center" auto>
            <cl-action-button
              class="outsider"
              [whiteBg]="true"
              (action)="openWebsite()"
              [label]="'account_menu.about.website' | translate : {website: config.env.companyWebsite}"
              [canClick]="true">
            </cl-action-button>
          </ion-col>
        </ion-row>

        <ion-row class="action-button hidden-btn">
          <ion-col class="ion-text-center" auto>
            <ion-button (click)="openDebug()" fill="clear"></ion-button>
          </ion-col>
        </ion-row>
      </div>

      <cl-download-links [showSubtitle]="false" *ngIf="config.isWebApp"></cl-download-links>

      <ion-row class="copyright">
        <ion-col class="ion-text-center">
          <p class="illustrations-info" [innerHTML]="'account_menu.about.illustrations' | translate"></p>
          <p class="copyright-info" [innerHTML]="'account_menu.about.copyright' | translate: copyrightParams"></p>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col class="ion-text-center">
          <div class="delete-account" (click)="deleteAccount()">{{ 'account_deletion.delete_account' | translate}}</div>
        </ion-col>
      </ion-row>
    </div>
  `
})
export class AboutComponent implements SettingsComponent {

  smokingType = SmokingType.CIGARETTE;

  constructor(
    public config: ClarityConfig,
    private browser: BrowserService,
    private translate: TranslateService,
    private analyticsService: AnalyticsService,
    private store: Store<State>
  ) {
    this.store.select(getCurrentUserProgram)
      .subscribe((userProgram) => {
        this.smokingType = userProgram.smoking_type;
      });
  }

  get copyrightParams() {
    return {
      programName: this.config.program.name,
      appVersion: this.config.env.app.app_version,
      appBuild: this.config.env.app.app_build,
      currentEnvironment: this.config.currentEnv(),
      copyrightYear: new Date().getFullYear()
    };
  }

  openTerms() {
    this.openLink(this.config.privacyTermsUrl);
  }

  openWebsite() {
    this.openLink(this.config.env.companyWebsiteUrl);
  }

  openLink(link: string) {
    this.browser.goTo(link);
  }

  share() {
    this.analyticsService.trackEvent(AnalyticsEvents.SharedApp);

    this.translate.get('account_menu.about.share_message', {programName: this.config.program.name})
      .pipe(take(1))
      .subscribe((translation: any) => {
        Share.share({
          text: translation,
          url: this.config.program.webUrl
        });
      });
  }

  async openDebug() {
    this.store.dispatch(new navigationActions.OpenModal('DebugPage'));
  }

  openIntroVideo() {
    this.store.dispatch(new navigationActions.OpenModal('WelcomeVideoPage'));
  }

  deleteAccount() {
    this.store.dispatch(new navigationActions.OpenModal('AccountDeletionPage'));
  }

}
